import { getAuthClient } from "@-/dev.improve.haniverse.lib.auth.client";

/**
 * Whether a user is signed in right now.
 *
 * Treats the pending window as signed-OUT deliberately. For content gating that is the safe
 * default: a guest who briefly sees the reveal prompt loses nothing, whereas optimistically
 * showing content to an unauthenticated viewer is the failure this gate exists to prevent.
 */
export function useIsSignedIn(): boolean {
  const { data: session } = getAuthClient().useSession();
  return session?.user != null;
}
